export enum Permission {
  StoreConfigsView = 'store_configs.view',
  CustomersCustomersView = 'customers_customers.view',
  CustomersUserImpersonationModifyAccess = 'customers_user_impersonation.modify',
  CustomersPrivacyRequestsModifyAccess = 'customers_privacy_requests.modify',
  CustomersAppeasementsModifyAccess = 'customers_appeasements.modify',
  CustomersAppeasementsView = 'customers_appeasements.view',
}
